<template>
  <div>
    <b-row>
      <b-col class="mb-4">
        <pcg-btn @click="backToIndex" size="small">
          &lt; {{ $t('general.back') }}
        </pcg-btn>
      </b-col>
    </b-row>
    <abk-competence-form :submitAction="updateCompetence"
                         :competenceId="competenceId"
                         :success-message="$t('views.competences.edit.competence_updated')"/>
  </div>
</template>

<script>
import ApiCompetences from '../../api/competences'
import AbkCompetenceForm from '../../components/competences/AbkCompetenceForm'
export default {
  name: 'CompetencesEdit',
  components: { AbkCompetenceForm },
  data () {
    return {
      competenceId: this.$route.params.id
    }
  },
  methods: {
    updateCompetence (competence) {
      return ApiCompetences.updateCompetence(this.competenceId, competence)
    },
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.competences.edit.title'),
        subtitle: this.$t('views.competences.edit.subtitle')
      })
    },
    backToIndex () {
      this.$router.push({ name: 'competences_list_all_tab_path' })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  }
}
</script>
